export default {
	month: {
		'en': 'month',
		'pt': 'mês',
		'es': 'mes',
		'ru': 'месяц',
		'tr': 'ay',
		'fr': 'mois',
		'de': 'Monat',
		'it': 'mese',
		'kz': 'ай',
	},
	name_label: {
		'en': 'First name',
		'pt': 'Primeiro nome',
		'es': 'Nombre',
		'ru': 'Имя',
		'tr': 'Adınız',
		'fr': 'Prénom',
		'de': 'Vorname',
		'it': 'Nome',
		'kz': 'Аты',
	},
	surname_label: {
		'en': 'Last name',
		'pt': 'Sobrenome',
		'es': 'Apellido',
		'ru': 'Фамилия',
		'tr': 'Soyadınız',
		'fr': 'Nom de famille',
		'de': 'Nachname',
		'it': 'Cognome',
		'kz': 'Тегі',
	},
	phone_label: {
		'en': 'Local Phone (US)',
		'pt': 'Telefone local (US)',
		'es': 'Teléfono local (US)',
		'ru': 'Местный телефон (US)',
		'tr': 'Yerel Telefon (US)',
		'fr': 'Téléphone local (US)',
		'de': 'Lokale Telefonnummer (US)',
		'it': 'Telefono locale (US)',
		'kz': 'Жергілікті телефон (US)',
	},
	phone2_label: {
		'en': 'Additional phone',
		'pt': 'Telefone adicional',
		'es': 'Teléfono adicional',
		'ru': 'Дополнительный телефон',
		'tr': 'Ek telefon',
		'fr': 'Téléphone supplémentaire',
		'de': 'Zusätzliche Telefonnummer',
		'it': 'Telefono aggiuntivo',
		'kz': 'Қосымша телефон',
	},
	email_label: {
		'en': 'E-mail',
		'pt': 'E-mail',
		'es': 'E-mail',
		'ru': 'E-mail',
		'tr': 'E-mail',
		'fr': 'E-mail',
		'de': 'E-Mail',
		'it': 'E-mail',
		'kz': 'E-mail',
	},
	address_label: {
		'en': 'Florida address',
		'pt': 'Endereço na Flórida',
		'es': 'Dirección en Florida',
		'ru': 'Адрес во Флориде',
		'tr': 'Florida adresi',
		'fr': 'Adresse en Floride',
		'de': 'Adresse in Florida',
		'it': 'Indirizzo in Florida',
		'kz': 'Флоридадағы мекенжай',
	},
	address_apartment_label: {
		'en': 'Apt # (if applicable)',
		'pt': 'Apto # (se aplicável)',
		'es': 'Apto # (si corresponde)',
		'ru': '№ апартаментов (если применимо)',
		'tr': 'Daire № (varsa)',
		'fr': 'Appart. n° (le cas échéant)',
		'de': 'Wohnung Nr. (falls zutreffend)',
		'it': 'App. n° (se applicabile)',
		'kz': 'Пәтер № (қажет болса)',
	},
	address_city_label: {
		'en': 'City',
		'pt': 'Cidade',
		'es': 'Ciudad',
		'ru': 'Город',
		'tr': 'Şehir',
		'fr': 'Ville',
		'de': 'Stadt',
		'it': 'Città',
		'kz': 'Қала',
	},
	address_state_label: {
		'en': 'State',
		'pt': 'Estado',
		'es': 'Estado',
		'ru': 'Штат',
		'tr': 'Eyalet',
		'fr': 'État',
		'de': 'Bundesland',
		'it': 'Stato',
		'kz': 'Штат',
	},
	address_state_default: {
		'en': 'Florida',
		'pt': 'Flórida',
		'es': 'Florida',
		'ru': 'Флорида',
		'tr': 'Florida',
		'fr': 'Floride',
		'de': 'Florida',
		'it': 'Florida',
		'kz': 'Флорида',
	},
	address_zip_label: {
		'en': 'Zip сode',
		'pt': 'Código zip',
		'es': 'Código zip',
		'ru': 'Zip код',
		'tr': 'Zip kodu',
		'fr': 'Code Zip',
		'de': 'Zip-Code',
		'it': 'Codice Zip',
		'kz': 'Zip коды',
	},
	chairs_label: {
		'en': 'Сhild seats',
		'pt': 'Cadeira de criança',
		'es': 'Silla para bebés',
		'ru': 'Детские кресла, шт.',
		'tr': 'Çocuk koltuğu',
		'fr': 'Sièges enfants',
		'de': 'Kindersitze',
		'it': 'Seggiolini per bambini',
		'kz': 'Балалар креслесі',
	},
	chairs_popover: {
		'en': `<div class='text-justify'>Renting a car from us you can get a child safety seat with no additional charge.<br><br>Florida Law requires children under 5 years old to be properly restrained no matter where they sit in a vehicle. Violation of child restraint Law carries a fine of $60.00 and 3 points on the driving record. If you rent a child safety seat from us, you are absolutely and solely responsible for proper choice of seat type and its installation.</div>`,
		'pt': `<div class='text-justify'>O custo do aluguel de cadeirinhas está incluído no preço do aluguel de carro.<br><br>A lei da Flórida exige que crianças menores de 5 anos sejam devidamente protegidas, não importa onde estejam sentadas em um veículo. A violação desta lei acarreta uma multa de $60,00 e 3 pontos no registro de condução. Se você alugar uma cadeirinha conosco, você será o único responsável pela escolha adequada do tipo de cadeira e sua instalação.</div>`,
		'es': `<div class='text-justify'>El coste del alquiler del asiento de bebé está incluido en el precio del alquiler del coche.<br><br>La ley de Florida requiere que los niños menores de 5 años estén debidamente protegidos sin importar dónde estén sentados en un vehículo. La violación de esta ley conlleva una multa de $60.00 y 3 puntos en el registro de manejo. Al alquilar un asiento infantil, eres el único responsable de elegir el tipo correcto e instalarlo.</div>`,
		'ru': `<div class='text-justify'>Стоимость аренды детских кресел входит в стоимость аренды автомобиля.<br><br>Законодательство штата Флорида требует, чтобы все дети возрастом до 5-ти лет включительно перевозились с использованием детских кресел вне зависимости от того, где они сидят в машине. Нарушение данного правила влечет штраф $60.00 и 3 штрафных балла к водительскому удостоверению. Если вы арендуете детские кресла у нас, ответственность за правильный выбор типа кресел и их установку лежит исключительно на вас.</div>`,
		'tr': `<div class='text-justify'>Bizden araç kiraladığınızda çocuk koltuğunu ek ücret olmadan alabilirsiniz.<br><br>Florida yasaları 5 yaşın altındaki çocukların araçta nerede otururlarsa otursunlar doğru şekilde bağlanmasını gerektirir. İhlal 60$ para cezası ve sürüş kaydına 3 puan getirir. Bizden çocuk koltuğu kiralarsanız doğru koltuk tipini seçmek ve doğru kurulumundan tamamen siz sorumlusunuz.</div>`,
		'fr': `<div class='text-justify'>En louant une voiture chez nous, vous pouvez obtenir un siège enfant sans supplément.<br><br>La loi de Floride exige que les enfants de moins de 5 ans soient correctement retenus, où qu'ils soient assis dans le véhicule. La violation de cette loi entraîne une amende de 60 $ et 3 points sur le permis. Si vous louez un siège enfant chez nous, vous êtes seul responsable du choix du type de siège et de son installation.</div>`,
		'de': `<div class='text-justify'>Wenn Sie bei uns ein Auto mieten, erhalten Sie einen Kindersitz ohne Aufpreis.<br><br>Das Gesetz von Florida verlangt, dass Kinder unter 5 Jahren ordnungsgemäß gesichert sind – egal wo sie im Fahrzeug sitzen. Ein Verstoß zieht ein Bußgeld von 60 $ und 3 Punkte im Fahrregister nach sich. Wenn Sie einen Kindersitz bei uns mieten, sind Sie allein für die richtige Wahl und Installation verantwortlich.</div>`,
		'it': `<div class='text-justify'>Noleggiando un'auto da noi puoi ottenere un seggiolino per bambini senza costi aggiuntivi.<br><br>La legge della Florida richiede che i bambini sotto i 5 anni siano correttamente fissati ovunque siedano nel veicolo. La violazione comporta una multa di 60 $ e 3 punti sulla patente. Se noleggi un seggiolino da noi, sei l'unico responsabile della scelta del tipo corretto e della sua installazione.</div>`,
		'kz': `<div class='text-justify'>Бізден көлік жалдасаңыз, балаларға арналған қауіпсіздік орындығын тегін ала аласыз.<br><br>Флорида заңы бойынша 5 жасқа дейінгі балалар көлікте қай жерде отырса да дұрыс бекітілуі тиіс. Ережені бұзу $60 айыппұл және жүргізуші жазбасына 3 балл қосады. Бізден балалар орындығын жалдағанда оның дұрыс түрін таңдау және орнату толықтай сіздің жауапкершілігіңізде.</div>`,
	},
	flight_label: {
		'en': 'Flight # (if applicable)',
		'pt': 'Voo (se aplicável)',
		'es': 'Vuelo (si aplica)',
		'ru': 'Авиарейс (если применимо)',
		'tr': 'Uçuş № (varsa)',
		'fr': 'Vol n° (le cas échéant)',
		'de': 'Flug Nr. (falls zutreffend)',
		'it': 'Volo n° (se applicabile)',
		'kz': 'Рейс № (қажет болса)',
	},
	flight_popover: {
		'en': `<div class='text-justify'>Если нам известен ваш авиарейс, мы сможем отслеживать его и быть в курсе возможных задержек. В этом случае мы сохраним ваше бронирование, даже если вы задерживаетесь.</div>`,
		'pt': `<div class='text-justify'>Если нам известен ваш авиарейс, мы сможем отслеживать его и быть в курсе возможных задержек. В этом случае мы сохраним ваше бронирование, даже если вы задерживаетесь.</div>`,
		'es': `<div class='text-justify'>Если нам известен ваш авиарейс, мы сможем отслеживать его и быть в курсе возможных задержек. В этом случае мы сохраним ваше бронирование, даже если вы задерживаетесь.</div>`,
		'ru': `<div class='text-justify'>Если нам известен ваш авиарейс, мы сможем отслеживать его и быть в курсе возможных задержек. В этом случае мы сохраним ваше бронирование, даже если вы задерживаетесь.</div>`,
		'tr': `<div class='text-justify'>Uçuş numaranızı bilirsek olası gecikmeleri takip eder ve haberdar oluruz. Bu sayede gecikseniz bile rezervasyonunuz korunur.</div>`,
		'fr': `<div class='text-justify'>Si nous connaissons votre numéro de vol, nous pouvons le suivre et être informés d'éventuels retards. Ainsi, nous conserverons votre réservation même en cas de retard.</div>`,
		'de': `<div class='text-justify'>Wenn wir Ihre Flugnummer kennen, können wir Verspätungen verfolgen. So behalten wir Ihre Reservierung auch bei einer Verzögerung.</div>`,
		'it': `<div class='text-justify'>Se conosciamo il tuo numero di volo possiamo monitorare eventuali ritardi e mantenere la prenotazione anche se arrivi in ritardo.</div>`,
		'kz': `<div class='text-justify'>Рейс нөміріңізді білсек, ықтимал кешігулерді бақылап, сіз кешіксеңіз де бронды сақтай аламыз.</div>`,
	},
	photo_label: {
		'en': 'Driver\'s license(s) (max 2 drivers)',
		'pt': 'Carta de condução (máximo 2 condutores)',
		'es': 'Licencia de conducir (máximo 2 conductores)',
		'ru': 'Водит. права (макс 2 водителя)',
		'tr': 'Ehliyet(лер) (en fazla 2 sürücü)',
		'fr': 'Permis de conduire (max 2 conducteurs)',
		'de': 'Führerschein(e) (max. 2 Fahrer)',
		'it': 'Patente(i) (max 2 conducenti)',
		'kz': 'Жүргізуші куәлігі (ең көбі 2 жүргізуші)',
	},
	photo_comments: {
		'en': 'Driver\'s license(s)',
		'pt': 'Carta de condução',
		'es': 'Licencia de conducir',
		'ru': 'Водительские права',
		'tr': 'Ehliyet(лер)',
		'fr': 'Permis de conduire',
		'de': 'Führerschein(e)',
		'it': 'Patente',
		'kz': 'Жүргізуші куәлігі',
	},
	photo_select_label: {
		'en': 'Attach',
		'pt': 'Anexar',
		'es': 'Adjuntar',
		'ru': 'Прикрепить',
		'tr': 'Ekle',
		'fr': 'Joindre',
		'de': 'Anhängen',
		'it': 'Allega',
		'kz': 'Қосу',
	},
	birthdate_label: {
		'en': 'Date of birth',
		'pt': 'Data de nascimento',
		'es': 'Fecha de nacimiento',
		'ru': 'Дата рождения',
		'tr': 'Doğum tarihi',
		'fr': 'Date de naissance',
		'de': 'Geburtsdatum',
		'it': 'Data di nascita',
		'kz': 'Туған күні',
	},
	birthdate_month_label: {
		'en': 'Month',
		'pt': 'Mês',
		'es': 'Mes',
		'ru': 'Месяц',
		'tr': 'Ay',
		'fr': 'Mois',
		'de': 'Monat',
		'it': 'Mese',
		'kz': 'Ай',
	},
	birthdate_date_label: {
		'en': 'Day',
		'pt': 'Dia',
		'es': 'Día',
		'ru': 'День',
		'tr': 'Gün',
		'fr': 'Jour',
		'de': 'Tag',
		'it': 'Giorno',
		'kz': 'Күн',
	},
	date_label: {
		'en': 'Select dates',
		'pt': 'Selecionar datas',
		'es': 'Seleccionar fechas',
		'ru': 'Выбрать даты',
		'tr': 'Tarihleri seç',
		'fr': 'Sélectionner les dates',
		'de': 'Daten auswählen',
		'it': 'Seleziona le date',
		'kz': 'Күндерді таңдаңыз',
	},
	date_start_label: {
		'en': 'Pick-up date',
		'pt': 'Data de recolha',
		'es': 'Fecha de recogida',
		'ru': 'Дата начала аренды',
		'tr': 'Alış tarihi',
		'fr': 'Date de prise en charge',
		'de': 'Abholdatum',
		'it': 'Data di ritiro',
		'kz': 'Алу күні',
	},
	date_end_label: {
		'en': 'Return date',
		'pt': 'Data de devolução',
		'es': 'Fecha de devolución',
		'ru': 'Дата возврата',
		'tr': 'İade tarihi',
		'fr': 'Date de retour',
		'de': 'Rückgabedatum',
		'it': 'Data di riconsegna',
		'kz': 'Қайтару күні',
	},
	time_start_label: {
		'en': 'Pick-up time',
		'pt': 'Hora de retirada',
		'es': 'Hora de recogida',
		'ru': 'Время начала аренды',
		'tr': 'Alış saati',
		'fr': 'Heure de prise en charge',
		'de': 'Abholzeit',
		'it': 'Ora di ritiro',
		'kz': 'Алу уақыты',
	},
	time_end_label: {
		'en': 'Return time',
		'pt': 'Hora de devolução',
		'es': 'Hora de devolución',
		'ru': 'Время возврата',
		'tr': 'İade saati',
		'fr': 'Heure de retour',
		'de': 'Rückgabezeit',
		'it': 'Ora di riconsegna',
		'kz': 'Қайтару уақыты',
	},
	note_label: {
		'en': 'Additional information',
		'pt': 'Informações adicionais',
		'es': 'Información adicional',
		'ru': 'Дополнительная информация',
		'tr': 'Ek bilgiler',
		'fr': 'Informations supplémentaires',
		'de': 'Zusätzliche Informationen',
		'it': 'Informazioni aggiuntive',
		'kz': 'Қосымша ақпарат',
	},
	data_is_secure: {
		'en': 'Your data is secure',
		'pt': 'Seus dados estão protegidos',
		'es': 'Sus datos están protegidos',
		'ru': 'Ваши данные защищены',
		'tr': 'Verileriniz güvende',
		'fr': 'Vos données sont sécurisées',
		'de': 'Ihre Daten sind sicher',
		'it': 'I tuoi dati sono al sicuro',
		'kz': 'Сіздің деректеріңіз қорғалған',
	},
	btn_name_send: {
		'en': 'Submit',
		'pt': 'Enviar',
		'es': 'Entregar',
		'ru': 'Забронировать',
		'tr': 'Gönder',
		'fr': 'Envoyer',
		'de': 'Senden',
		'it': 'Invia',
		'kz': 'Жіберу',
	},
	btn_name_send_comment: {
		'en': 'Advance booking is free.',
		'pt': 'A reserva antecipada é gratuita.',
		'es': 'La reserva anticipada es gratuita.',
		'ru': 'Предварительное бронирование бесплатно.',
		'tr': 'Ön rezervasyon ücretsizdir.',
		'fr': 'La réservation anticipée est gratuite.',
		'de': 'Frühbuchung ist kostenlos.',
		'it': 'La prenotazione anticipata è gratuita.',
		'kz': 'Алдын ала брондау тегін.',
	},
	form_title: {
		'en': 'Reservation',
		'pt': 'Reserva',
		'es': 'Reserva',
		'ru': 'Бронирование',
		'tr': 'Rezervasyon',
		'fr': 'Réservation',
		'de': 'Reservierung',
		'it': 'Prenotazione',
		'kz': 'Брондау',
	},
	form_anons: {
		'en': 'The following information is required for reservation',
		'pt': 'Para fazer a reserva, são necessárias as seguintes informações',
		'es': 'Para hacer una reserva se requiere la siguiente información',
		'ru': 'Для оформления бронирования требуется следующая информация',
		'tr': 'Rezervasyon için aşağıdaki bilgiler gerekli',
		'fr': 'Les informations suivantes sont requises pour la réservation',
		'de': 'Für die Reservierung werden folgende Informationen benötigt',
		'it': 'Per la prenotazione sono richieste le seguenti informazioni',
		'kz': 'Брондау үшін келесі ақпарат қажет',
	},
	phone_title: {
		'en': 'Local phone (US)',
		'pt': 'Telefone local (US)',
		'es': 'Teléfono local (US)',
		'ru': 'Местный (US) телефон',
		'tr': 'Yerel telefon (US)',
		'fr': 'Téléphone local (US)',
		'de': 'Lokaler (US) Telefon',
		'it': 'Telefono locale (US)',
		'kz': 'Жергілікті (US) телефон',
	},
	phone2_title: {
		'en': 'Additional phone',
		'pt': 'Telefone adicional',
		'es': 'Teléfono adicional',
		'ru': 'Дополнительный телефон',
		'tr': 'Ek telefon',
		'fr': 'Téléphone supplémentaire',
		'de': 'Zusätzlicher Telefon',
		'it': 'Telefono aggiuntivo',
		'kz': 'Қосымша телефон',
	},
	date_txt: {
		'en': 'I know the exact rental date',
		'pt': 'Eu sei a data exata de aluguel',
		'es': 'Sé la fecha exacta de alquiler',
		'ru': 'Я знаю точную дату аренды',
		'tr': 'Kesin kiralama tarihini biliyorum',
		'fr': 'Je connais la date exacte de location',
		'de': 'Ich kenne das genaue Mietdatum',
		'it': 'Conosco la data esatta di noleggio',
		'kz': 'Дәл жалға алу күнін білемін',
	},
	personal_title: {
		'en': 'I consent to the processing of my personal data',
		'pt': 'Autorizo o processamentro dos meus dados pessoais',
		'es': 'Acepto el tratamiento de mis datos personales.',
		'ru': 'Я даю согласие на обработку своих персональных данных',
		'tr': 'Kişisel verilerimin işlenmesine izin veriyorum',
		'fr': 'Je consens au traitement de mes données personnelles',
		'de': 'Ich willige in die Verarbeitung meiner personenbezogenen Daten ein',
		'it': 'Acconsento al trattamento dei miei dati personali',
		'kz': 'Жеке деректерімді өңдеуге келісім беремін',
	},
	form_msg_error: {
		'en': 'Required fields are not filled out',
		'pt': 'Não todos os campos estão preenchidos!',
		'es': '¡No todos los campos están llenos!',
		'ru': 'Не заполнены обязательные поля',
		'tr': 'Zorunlu alanlar doldurulmadı',
		'fr': 'Les champs obligatoires ne sont pas remplis',
		'de': 'Pflichtfelder sind nicht ausgefüllt',
		'it': 'I campi obbligatori non sono compilati',
		'kz': 'Міндетті өрістер толтырылмаған',
	},
	form_msg_thanks: {
		'en': 'Thank you for the information provided.',
		'pt': 'Obrigado pela informação fornecida.',
		'es': 'Gracias por la información proporcionada.',
		'ru': 'Спасибо за предоставленную информацию.',
		'tr': 'Verdiğiniz ақпарат үшін рахмет.',
		'fr': 'Merci pour les informations fournies.',
		'de': 'Vielen Dank für die bereitgestellten Informationen.',
		'it': 'Grazie per le informazioni fornite.',
		'kz': 'Берілген ақпарат үшін рахмет.',
	},
	form_msg_sended: {
		'en': 'We will process it and send you <br>a confirmation.',
		'pt': 'Nós iremos processá-lo e enviar-lhe uma <br>confirmação.',
		'es': 'La procesaremos y le enviaremos una <br>confirmación.',
		'ru': 'Мы обработаем ее и вышлем вам <br>подтверждение.',
		'tr': 'İşleyip size bir <br>onay göndereceğiz.',
		'fr': 'Nous la traiterons et vous enverrons une <br>confirmation.',
		'de': 'Wir verarbeiten sie und senden Ihnen eine <br>Bestätigung.',
		'it': 'La elaboreremo e ti invieremo una <br>conferma.',
		'kz': 'Біз оны өңдеп сізге <br>растау жібереміз.',
	},
	form_error: {
		'en': 'Not all required fields are filled out!',
		'pt': 'Não todos os campos estão preenchidos!',
		'es': '¡No todos los campos están llenos!',
		'ru': 'Не все поля заполнены!',
		'tr': 'Tüm gerekli alanlar doldurulmadı!',
		'fr': 'Tous les champs requis ne sont pas remplis !',
		'de': 'Nicht alle Pflichtfelder sind ausgefüllt!',
		'it': 'Non tutti i campi obbligatori sono compilati!',
		'kz': 'Барлық міндетті өрістер толтырылмаған!',
	},
	form_error_start_date: {
		'en': 'Enter pick-up date and time',
		'pt': 'Insira a data e hora de retirada',
		'es': 'Ingrese la fecha y hora de recogida',
		'ru': 'Укажите дату и время начала аренды',
		'tr': 'Alış tarihini ve saatini girin',
		'fr': 'Entrez la date et l\'heure de prise',
		'de': 'Geben Sie Abholdatum und -zeit ein',
		'it': 'Inserisci data e ora di ritiro',
		'kz': 'Алу күні мен уақытын енгізіңіз',
	},
	form_error_end_date: {
		'en': 'Enter return date and time',
		'pt': 'Insira a data e hora de retorno',
		'es': 'Ingrese la fecha y hora de regreso',
		'ru': 'Укажите дату и время возврата',
		'tr': 'İade tarih және сағатты енгізіңіз',
		'fr': 'Entrez la date et l\'heure de retour',
		'de': 'Geben Sie Rückgabedatum и -zeit ein',
		'it': 'Inserisci data e ora di riconsegna',
		'kz': 'Қайтару күні мен уақытын енгізіңіз',
	},
	form_error_name: {
		'en': 'Enter your name',
		'pt': 'Digite seu nome',
		'es': 'Introduzca su nombre',
		'ru': 'Укажите ваше имя',
		'tr': 'Adınızı girin',
		'fr': 'Entrez votre nom',
		'de': 'Geben Sie Ihren Namen ein',
		'it': 'Inserisci il tuo nome',
		'kz': 'Атыңызды енгізіңіз',
	},
	form_error_age: {
		'en': 'Your age doesn’t meet our criteria',
		'pt': 'Sua idade não atende aos nossos critérios',
		'es': 'Tu edad no cumple con nuestros criterios',
		'ru': 'Ваш возраст не соответствует критериям',
		'tr': 'Yaşınız kriterlerimizi қарсыламıyor',
		'fr': 'Votre âge ne correspond pas à nos critères',
		'de': 'Ihr Alter entspricht nicht unseren Kriterien',
		'it': 'La tua età non soddisfa i nostri criteri',
		'kz': 'Жасыңыз біздің критерийлерге сай емес',
	},
	form_error_whatsApp: {
		'en': 'Enter at least one phone # with WhatsApp',
		'pt': 'Insira pelo menos um número de telefone com WhatsApp',
		'es': 'Ingresa al menos un número de teléfono con WhatsApp',
		'ru': 'Укажите хотя бы один телефон с WhatsApp',
		'tr': 'WhatsApp bulunan en az бір телефон girin',
		'fr': 'Entrez au moins un numéro avec WhatsApp',
		'de': 'Geben Sie mindestens eine Telefonnummer mit WhatsApp ein',
		'it': 'Inserisci almeno un numero con WhatsApp',
		'kz': 'Кемінде бір WhatsApp бар телефон енгізіңіз',
	},
	form_error_email: {
		'en': 'Enter your e-mail',
		'pt': 'Digite seu e-mail',
		'es': 'Introduce tu e-mail',
		'ru': 'Укажите e-mail',
		'tr': 'E-mailinizi girin',
		'fr': 'Entrez votre e-mail',
		'de': 'Geben Sie Ihre E-Mail ein',
		'it': 'Inserisci la tua e-mail',
		'kz': 'E-mail енгізіңіз',
	},
	form_error_photos: {
		'en': 'To confirm the booking, please attach a photo of your driver’s license.',
		'pt': 'Para confirmar a reserva, por favor, envie uma foto da sua carteira de motorista.',
		'es': 'Para confirmar la reserva, por favor adjunte uma foto de su licencia de conducir.',
		'ru': 'Для подтверждения бронирования, пожалуйста, прикрепите фото водительского удостоверения.',
		'tr': 'Rezervasyonu onaylamak үшін ehliет фотоğrafы ekleyin.',
		'fr': 'Pour confirmer la réservation, veuillez joindre une photo de votre permis.',
		'de': 'Um die Buchung zu bestätigen, fügen Sie bitte ein Foto Ihres Führerscheins bei.',
		'it': 'Per confermare la prenotazione, allega la foto della patente.',
		'kz': 'Брондауды растау үшін жүргізуші куәлігінің фотосын тіркеңіз.',
	},
	form_error_address: {
		'en': 'Enter your complete address',
		'pt': 'Digite seu endereço completo',
		'es': 'Introduce tu dirección completa',
		'ru': 'Укажите ваш полный адрес',
		'tr': 'Tam адресinizi girin',
		'fr': 'Entrez votre adresse complète',
		'de': 'Geben Sie Ihre vollständige Adresse ein',
		'it': 'Inserisci il tuo indirizzo completo',
		'kz': 'Толық мекенжайыңызды енгізіңіз',
	},
	form_error_startDateToLate: {
		'en': ' The start date you entered is too far from the date the car becomes available. We cannot keep the car idle for so long. If you need to discuss an individual solution, contact us via WhatsApp',
		'pt': ' A data de início que você inseriu está muito distante da data em que o carro fica disponível. Não podemos manter o carro parado por tanto tempo. Se você precisa discutir uma solução individual, entre em contato via WhatsApp',
		'es': ' La fecha de inicio que ingresó está demasiado lejos de la fecha en que el automóvil está disponible. No podemos mantener el automóvil inativo tanto tiempo. Si necesita una solución individual, contáctenos por WhatsApp',
		'ru': 'Введенная вами дата начала бронирования слишком далеко от даты, когда автомобиль становится доступным. Мы не можем держать автомобиль в простое так долго. Если необходимо обсудить индивидуальное решение, свяжитесь с нами по WhatsApp',
		'tr': ' Girdiğiniz басталу күні көліктің қолжетімді болатын күнінен тым алыс. Біз көлікті сонша уақыт бос ұстай алмаймыз. Жеке шешім үшін WhatsApp арқылы хабарласыңыз',
		'fr': ' La date de début saisie est trop éloignée de la date de disponibilité du véhicule. Nous ne pouvons pas laisser la voiture inactive si longtemps. Pour une solution individuelle, contactez-nous via WhatsApp',
		'de': ' Das eingegebene Startdatum liegt zu weit von dem Datum entfernt, an dem das Fahrzeug verfügbar wird. Wir können das Auto nicht so lange untätig halten. Für eine individuelle Lösung kontaktieren Sie uns bitte per WhatsApp',
		'it': ' La data di inizio inserita è troppo lontana dalla data in cui l\'auto sarà disponibile. Non possiamo tenere l\'auto ferma così a lungo. Per una soluzione individuale contattaci su WhatsApp',
		'kz': ' Енгізген басталу күні көліктің қолжетімді болатын күнінен тым алыс. Біз көлікті сонша уақыт бос ұстай алмаймыз. Жеке шешім үшін WhatsApp арқылы хабарласыңыз',
	},
	form_btn_send: {
		'en': 'Submit',
		'pt': 'Enviar',
		'es': 'Entregar',
		'ru': 'Отправить',
		'tr': 'Gönder',
		'fr': 'Envoyer',
		'de': 'Senden',
		'it': 'Invia',
		'kz': 'Жіберу',
	},
	server_errors_translations: {
		available: {
			'en': 'Car not found or not available!',
			'pt': 'Carro não encontrado ou não disponível!',
			'es': '¡Coche no encontrado o no disponible!',
			'ru': 'Автомобиль не найден или недоступен!',
			'tr': 'Araç bulunamadı veya uygun değil!',
			'fr': 'Véhicule introuvable ou indisponible !',
			'de': 'Fahrzeug nicht gefunden oder nicht verfügbar!',
			'it': 'Auto non trovata o non disponibile!',
			'kz': 'Көлік табылмады немесе қолжетімсіз!',
		}
	},
	server_warnings_translations: {
		available: {
			'en': {
				'title': 'Thank you for the information!',
				'text': 'Unfortunately, while you were completing your reservation, this car was booked by another customer. We will manually process your request and offer a similar car. This may take a bit more time, and we appreciate your patience.'
			},
			'pt': {
				'title': 'Obrigado pelas informações!',
				'text': 'Infelizmente, enquanto você estava finalizando sua reserva, este carro foi reservado por outro cliente. Vamos processar sua solicitação manualmente e oferecer um carro semelhante. Isso pode levar um pouco mais de tempo, e agradecemos sua paciência.'
			},
			'es': {
				'title': '¡Gracias por la información!',
				'text': 'Lamentablemente, mientras completaba su reserva, este coche fue reservado por otro cliente. Procesaremos su solicitud manualmente y le ofreceremos un coche similar. Esto puede tomar un poco más de tiempo, y agradecemos su paciencia.'
			},
			'ru': {
				'title': 'Спасибо за предоставленную информацию!',
				'text': 'К сожалению, пока вы оформляли бронирование, этот автомобиль был забронирован другим клиентом. Мы вручную обработаем вашу заявку и предложим похожий автомобиль. Это может занять немного больше времени, благодарим за терпение.'
			},
			'tr': {
				'title': 'Bilgiler için teşekkürler!',
				'text': 'Ne yazık ki siz rezervasyonu tamamlarken bu araç başka bir müşteri tarafından rezerve edildi. Talebinizi manuel olarak işleyip benzer bir araç önereceğiz. Bu biraz daha zaman alabilir; sabrınız için teşekkür ederiz.'
			},
			'fr': {
				'title': 'Merci pour les informations !',
				'text': 'Malheureusement, pendant que vous complétiez votre réservation, ce véhicule a été réservé par un autre client. Nous traiterons votre demande manuellement et proposerons un véhicule similaire. Cela peut prendre un peu plus de temps; merci de votre patience.'
			},
			'de': {
				'title': 'Danke für die Informationen!',
				'text': 'Leider wurde dieses Fahrzeug gebucht, während Sie die Reservierung ausfüllten. Wir bearbeiten Ihre Anfrage manuell und bieten ein ähnliches Fahrzeug an. Das kann etwas länger dauern – danke für Ihre Geduld.'
			},
			'it': {
				'title': 'Grazie per le informazioni!',
				'text': 'Purtroppo mentre completavi la prenotazione questa auto è stata prenotata da un altro cliente. Elaboreremo manualmente la tua richiesta e ti offriremo un\'auto simile. Potrebbe richiedere un po\' più di tempo; grazie per la pazienza.'
			},
			'kz': {
				'title': 'Ақпарат үшін рахмет!',
				'text': 'Өкінішке орай, сіз брондауды толтырып жатқанда бұл көлік басқа клиентке берілді. Өтінішіңіз қолмен өңделіп, ұқсас көлік ұсынылады. Бұл сәл ұзақ уақыт алуы мүмкін, түсінушілікке рахмет.'
			}
		}
	},
	month_list: {
		'en': [
			'January', 'February', 'March', 'April',
			'May', 'June', 'July', 'August',
			'September', 'October', 'November', 'December',
		],
		'pt': [
			'Janeiro', 'Fevereiro', 'Março', 'Abril',
			'Maio', 'Junho', 'Julho', 'Agosto',
			'Setembro', 'Outubro', 'Novembro', 'Dezembro',
		],
		'es': [
			'Enero', 'Febrero', 'Marzo', 'Abril',
			'Mayo', 'Junio', 'Julio', 'Agosto',
			'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
		],
		'ru': [
			'Январь', 'Февраль', 'Март', 'Апрель',
			'Май', 'Июнь', 'Июль', 'Август',
			'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь',
		],
		'tr': [
			'Ocak', 'Şubat', 'Mart', 'Nisan',
			'Mayıs', 'Haziran', 'Temmuz', 'Ağustos',
			'Eylül', 'Ekim', 'Kasım', 'Aralık',
		],
		'fr': [
			'Janvier', 'Février', 'Mars', 'Avril',
			'Mai', 'Juin', 'Juillet', 'Août',
			'Septembre', 'Octobre', 'Novembre', 'Décembre',
		],
		'de': [
			'Januar', 'Februar', 'März', 'April',
			'Mai', 'Juni', 'Juli', 'August',
			'September', 'Oktober', 'November', 'Dezember',
		],
		'it': [
			'Gennaio', 'Febbraio', 'Marzo', 'Aprile',
			'Maggio', 'Giugno', 'Luglio', 'Agosto',
			'Settembre', 'Ottobre', 'Novembre', 'Dicembre',
		],
		'kz': [
			'Қаңтар', 'Ақпан', 'Наурыз', 'Сәуір',
			'Мамыр', 'Маусым', 'Шілде', 'Тамыз',
			'Қыркүйек', 'Қазан', 'Қараша', 'Желтоқсан',
		],
	}
};
